import { render, staticRenderFns } from "./Toolbox.vue?vue&type=template&id=48b774e7&scoped=true&"
import script from "./Toolbox.vue?vue&type=script&lang=ts&"
export * from "./Toolbox.vue?vue&type=script&lang=ts&"
import style0 from "./Toolbox.vue?vue&type=style&index=0&id=48b774e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b774e7",
  null
  
)

export default component.exports